<template>
  <router-link :to="link" class="list-group-item">
    <div class="media">
      <div class="media-left valign-middle">
        <i class="icon-bg-circle" :class="iconClass"></i>
      </div>
      <div class="media-body">
        <h6 class="media-heading" :class="titleClass">{{title}}</h6>
        <p class="notification-text font-small-3 text-muted">{{message}}</p>
        <small>
          <time :datetime="datetime" class="media-meta text-muted">{{since}}</time>
        </small>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "notification",
  props: {
    message: String,
    datetime: String,
    type: String,
    seen: Boolean,
  },
  computed: {
    since() {
      let date = new Date(this.datetime);

      let seconds = Math.floor((new Date() - date) / 1000);

      let interval = seconds / 31536000;

      if (interval > 1) {
        return Math.floor(interval) + " лет назад";
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return Math.floor(interval) + " месяцев назад";
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return Math.floor(interval) + " дней назад";
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return Math.floor(interval) + " часов назад";
      }
      interval = seconds / 60;
      if (interval > 1) {
        return Math.floor(interval) + " минут назад";
      }
      return "Меньше минуты назад";
    },
    iconClass() {
      let c = "";
      switch (this.type) {
        case "bill":
          c = "icon-file-text2 bg-info";
          break;
        case "waybill":
          c = "icon-paste2 bg-success";
          break;
        case "invoice":
          c = "icon-file-text3 bg-primary";
          break;
        default:
          c = "icon-mail6 bg-warning";
          break;
      }
      if (this.seen) c += " bg-grey";
      return c;
    },
    titleClass() {
      if (this.seen) return "text-muted";
      else
        switch (this.type) {
          case "bill":
            return "info";
          case "waybill":
            return "success";
          case "invoice":
            return "primary";
          default:
            return "warning darken-2";
        }
    },
    title() {
      switch (this.type) {
        case "bill":
          return "Новый счёт";
        case "waybill":
          return "Новая накладная";
        case "invoice":
          return "Новый счёт-фактура";
        default:
          return "Сообщение";
      }
    },
    link() {
      switch (this.type) {
        case "bill":
          return "/requests";
        case "waybill":
          return "/requests";
        case "invoice":
          return "/requests";
        default:
          return "";
      }
    },
  },
};
</script>